import { envName } from "@faire/web/common/user-agent/envName";
import { isProduction } from "@faire/web/common/user-agent/isProduction";
import { releaseVersion } from "@faire/web/common/user-agent/releaseVersion";

export const isLocal = (): boolean =>
  (!isProduction() && releaseVersion()?.indexOf("static") === 0) ||
  envName() === "local";
